export default {
      id: "icon-facebook-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "icons.svg#icon-facebook",
      toString: function () {
        return this.url;
      }
    }